export default __webpack_public_path__ + "static/media/gallery_13.3b7abcb0.jpg";